import { render } from "./ny-system-users-profile-form.vue?vue&type=template&id=64959dd8&scoped=true"
import script from "./ny-system-users-profile-form.vue?vue&type=script&lang=js"
export * from "./ny-system-users-profile-form.vue?vue&type=script&lang=js"

import "./ny-system-users-profile-form.vue?vue&type=style&index=0&id=64959dd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64959dd8"]])

export default __exports__